import React, { useState, useEffect, useRef } from "react"
import { usePost } from "../../../../hooks/usePost"
import FluentSendSVG from "../../../../images/fluent-send.inline.svg"
import CheckCircleOutlined from "../../../../assets/icons/CheckCircleOutlined.inline.svg"
import CloseCircleOutlined from "../../../../assets/icons/CloseCircleOutlined.inline.svg"
import { makeAbsoluteUrl } from "../../../../utility"
import * as styles from "./InputEmail.module.css"

type InputEmailProps = {
  name?: string
  url: string
  section: string
}

const InputEmail = ({ name, section, url }: InputEmailProps) => {
  const [email, setEmail] = useState("")
  const [sendingNewsletterStatus, setSendingNewsletterStatus] = useState<
    "success" | "fail"
  >()

  const { data, loading, save, error } = usePost("NewsLetter")

  const FormRef = useRef<HTMLFormElement>(null)

  useEffect(() => {
    if (!loading && (data || error)) {
      if (data && !error) {
        setEmail("")
        setSendingNewsletterStatus("success")
      }
      if (error && !data) {
        setSendingNewsletterStatus("fail")
      }
      const resetStatus = setTimeout(() => {
        setSendingNewsletterStatus(undefined)
      }, 1000)

      return () => clearTimeout(resetStatus)
    }
  }, [error, data, loading])

  const sendNewsletter = (e: React.FormEvent) => {
    e.preventDefault()

    if (FormRef.current?.checkValidity()) {
      save({
        fields: [
          {
            name: "email",
            value: email,
          },
        ],
        context: {
          pageName: name ? `${section} | ` + name : section,
          pageUri: makeAbsoluteUrl(url),
        },
      })
    }
    FormRef.current?.reportValidity()
  }

  return (
    <form ref={FormRef} onSubmit={e => sendNewsletter(e)}>
      <div className={styles.email}>
        <input
          type="email"
          placeholder="Your Email"
          value={email}
          onChange={e => setEmail(e.target.value)}
          required
          aria-label="Email Address"
        />
        <div className={styles.sendButton} onClick={sendNewsletter}>
          {sendingNewsletterStatus === "success" ? (
            <CheckCircleOutlined />
          ) : sendingNewsletterStatus === "fail" ? (
            <CloseCircleOutlined />
          ) : (
            <FluentSendSVG />
          )}
        </div>
      </div>
    </form>
  )
}

export default InputEmail
